import { render, staticRenderFns } from "./ReadingTaskConfig.vue?vue&type=template&id=4b2c68d5"
import script from "./ReadingTaskConfig.vue?vue&type=script&lang=js"
export * from "./ReadingTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./ReadingTaskConfig.vue?vue&type=style&index=0&id=4b2c68d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports